var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke secondary-fill",
    strokeLinejoin: "round",
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M13.22 16.7c0-.83-.47-1.29-1.36-1.29-.78 0-1.3.46-1.32 1.3 0 .83.52 1.29 1.33 1.29.88 0 1.35-.45 1.35-1.3ZM10.55 11.95c0-.07.02-.14.08-.18.17-.15.78-.34 1.43-.7 1.04-.59 1.25-1.28 1.25-2.13 0-.87-.81-1.5-1.85-1.5-.6 0-1.33.17-1.91.33-.16.04-.32-.09-.3-.24v-1.5a.2.2 0 0 1 .14-.16 9.51 9.51 0 0 1 2.64-.37c1.84 0 3.22 1.59 3.22 3.54 0 1.27-.46 2.28-1.4 2.91-.18.16-1.1.7-1.1.7l.02 1.47c.01.12-.1.23-.22.23H10.9a.22.22 0 0 1-.22-.2l-.13-2.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion24);
export default __webpack_public_path__ + "static/media/question_24.7015afbf286772f56deaed638a481ddf.svg";
export { ForwardRef as ReactComponent };